import { Brand } from '@awaze/design-system.components.awaze-theme-provider'
import React from 'react'

interface ApplicationConfigContext {
  brand: Brand
  clientHeader: string
  contentfulLocale: string
  currency: string
  themeBrand: Brand
}

export const ApplicationConfigContext =
  React.createContext<ApplicationConfigContext>(null)
